import React, { useState } from 'react';

import Breadcrumb from '../Breadcrumb';

import {
  AvatarImage, DropdownUsername, MainHeader, UserContainer, UserName,
} from './styles';
import UserPerfil from '../UserPerfil';
import { useUser } from '../../hooks/user';
import { pickTextColorBasedOnBgColorSimple } from '../../utils/getFontDarkOrLight';
import { Dropdown, DropdownItemProps, Image } from 'semantic-ui-react';
import { SignOut, User } from 'phosphor-react';

interface Props {
  screen: string;
  logout: () => Promise<void>;
}

const Header: React.FC<Props> = ({ screen, logout }) => {
  const [dropDownOpen, setDropDownOpen] = useState(false)

  const {
    userInfo
  } = useUser()

  function closeModal() {
    setDropDownOpen(false)
  }

  const dropdownOptions: DropdownItemProps[] = [
    { key: 'user', text: 'Minha Conta', icon: <User weight="thin" size={19} style={{ marginRight: '0.5rem', color: '#56B8F8' }} /> },
    { key: 'sign-out', text: 'Sair', icon: <SignOut weight="thin"  size={19} style={{ marginRight: '0.5rem', color: '#56B8F8' }} />, onClick: logout }
  ].filter(Boolean) 

  const dropdownTrigger = (
    <DropdownUsername>
      <Image avatar src={userInfo.foto === '' ? `https://ui-avatars.com/api/?background=${userInfo.color?.replace('#', '')}&color=${pickTextColorBasedOnBgColorSimple(userInfo.color).replace('#', '')}&name=${userInfo.nome}` : userInfo.foto} /> {userInfo.nome}
    </DropdownUsername>
  )

  return (
    <MainHeader>
      <Breadcrumb screen={screen} />

      <DropdownUsername>
        <Image avatar src={userInfo.foto === '' ? `https://ui-avatars.com/api/?background=${userInfo.color?.replace('#', '')}&color=${pickTextColorBasedOnBgColorSimple(userInfo.color).replace('#', '')}&name=${userInfo.nome}` : userInfo.foto} /> {userInfo.nome}
      </DropdownUsername>
      {/* <Dropdown
        inline
        trigger={dropdownTrigger}
        options={dropdownOptions}         
      /> */}
      {/* <UserContainer className='userPerfil' onClick={() => setDropDownOpen(!dropDownOpen)}>
        <UserName className='userPerfil'>{userInfo.nome}</UserName>
        <AvatarImage className='userPerfil' src={userInfo.foto === '' ? `https://ui-avatars.com/api/?background=${userInfo.color?.replace('#', '')}&color=${pickTextColorBasedOnBgColorSimple(userInfo.color).replace('#', '')}&name=${userInfo.nome}` : userInfo.foto} alt="Avatar" /> */}
        {/* <FaChevronDown size={30} color="#9c9c9c" style={{ cursor: 'pointer', marginLeft: 10 }} /> */}
        {/* <FaPowerOff size={30} color="#9c9c9c" style={{ cursor: 'pointer', marginLeft: 10 }} onClick={logout} /> */}
        {/* <BsThreeDotsVertical size={20} color='#9c9c9c' style={{ cursor: 'pointer' }} /> */}
      {/* </UserContainer>
      <UserPerfil close={closeModal} isOpen={dropDownOpen} logout={logout} /> */}

    </MainHeader>
  );
}

export default Header;